function resizeIframe(obj) {
  obj.style.height = obj.contentWindow.document.body.scrollHeight + 25 + 'px';
}

//Java Script functions to support Calculators Blog and other locations on site as needed

//General purpose audio conversion functions

function percent_to_db(percent) {
return 20 * Math.log10(percent / 100);
}

function db_to_percent(db) {
return 100 * Math.pow(10,db / 20);
}

function vrms_to_dbu(vrms) {
return 20 * Math.log10(vrms / Math.sqrt(0.6));
}

function dbu_to_vrms(dbu) {
return Math.pow(10,(dbu/ 20)) * Math.sqrt(0.6);
}

function dbu_to_dbv(dbu) {
return dbu + (20 * Math.log10(Math.sqrt(0.6)));
}

function dbv_to_dbu(dbv) {
return dbv - (20 * Math.log10(Math.sqrt(0.6)));
}

function power_to_vrms(watts, ohms) {
return Math.sqrt(watts * ohms);
}

function power_to_dbu(watts, ohms) {
return vrms_to_dbu(Math.sqrt(watts * ohms));
}

function dbu_to_power(dbu, ohms) {
return Math.pow(dbu_to_vrms(dbu),2) / ohms;
}

function power_to_dbw(watts, ohms) {
return gain_from_ratio(power_to_vrms(watts, ohms),power_to_vrms(1,8));
}

function dbu_to_dbw(dbu, ohms) {
return gain_from_ratio(power_to_vrms(1,ohms),dbu_to_vrms(dbu));
}

function mw_to_dbm(mw) {
  return 10 * Math.log10(mw);
}

function watts_to_dbw(watts) {
  return 10 * Math.log10(watts);
}

function dbm_to_mw(dbm) {
  return Math.pow(10,dbm/10);
}

function dbw_to_watts(dbw) {
  return Math.pow(10,dbw/10);
}

function vrms_to_vpp(vrms) {
return 2 * vrms * Math.sqrt(2);
}

function gain_from_ratio(v_in, v_out) {
return 20 * Math.log10(v_out / v_in);
}

function vout_from_gain(v_in, db_gain) {
return v_in * Math.pow(10,(db_gain / 20));
}

function peakspl(speaker_veff, power_8ohm) {
return (1 *speaker_veff) + (10 * Math.log10(power_8ohm));
}

function p_to_v_sensitivity(psens, impedance) {
return psens + (20 * Math.log10(Math.sqrt(8) / Math.sqrt(impedance)));
}

function snr_to_enob(sinad){
return (sinad - 1.76)/6.02;
}

function enob_to_snr(enob){
return (enob * 6.02) + 1.76;
}

// Form processing functions for forms on Blog pages

function percent_db(form) {
form.thd_db.value = (percent_to_db(form.percent_thd.value * 1)).toFixed(1);
}

function db_percent(form) {
form.percent_thd.value = (db_to_percent(form.thd_db.value * 1)).toFixed(6);
}

function volts_rms_to_dbu(form) {
form.dbu.value = vrms_to_dbu(form.volts_rms.value *1 );
form.dbv.value = (dbu_to_dbv(form.dbu.value *1 )).toFixed(3);
form.dbu.value = (form.dbu.value *1 ).toFixed(3);
form.volts_pp.value = vrms_to_vpp(form.volts_rms.value * 1).toFixed(3);
}

function dbu_to_volts(form) {
form.volts_rms.value = (dbu_to_vrms(form.dbu.value *1)).toFixed(3);
form.dbv.value = (dbu_to_dbv(form.dbu.value *1 )).toFixed(3);  
form.volts_pp.value = vrms_to_vpp(form.volts_rms.value * 1).toFixed(3);
}

function amplifier_output_noise(form) {
form.volts_rms.value = power_to_vrms(form.power.value * 1, 8);
form.dbu.value = vrms_to_dbu(form.volts_rms.value * 1);
form.noise_dbu.value = form.dbu.value - form.snr.value;
form.noise_rms_uv.value = 1000000 * dbu_to_vrms(form.noise_dbu.value * 1);
form.snr_1watt.value = power_to_dbu(1,8) - form.noise_dbu.value;
form.volts_rms.value = (form.volts_rms.value * 1).toFixed(2);
form.dbu.value = (form.dbu.value * 1).toFixed(2);
form.noise_dbu.value = (form.noise_dbu.value * 1).toFixed(2);
form.noise_rms_uv.value = (form.noise_rms_uv.value * 1).toFixed(2);
form.snr_1watt.value = (form.snr_1watt.value * 1).toFixed(2);
form.noise_dbw.value= (dbu_to_dbw(form.noise_dbu.value, 8)).toFixed(2);
}

function amplifier_output(form) {
form.volts_rms.value = power_to_vrms(form.power.value * 1, form.impedance.value * 1);
form.volts_pp.value = vrms_to_vpp(form.volts_rms.value * 1);
form.volts_peak.value = (form.volts_pp.value / 2).toFixed(2);
form.volts_pp.value = (form.volts_pp.value * 1).toFixed(2);  
form.dbu.value = (vrms_to_dbu(form.volts_rms.value * 1)).toFixed(2);
form.current_rms.value = (form.power.value / form.volts_rms.value).toFixed(2);
form.current_peak.value = (form.power.value / form.volts_rms.value * Math.sqrt(2)).toFixed(2);
form.volts_rms.value = (form.volts_rms.value * 1).toFixed(2);
}

function ratio_to_db(form) {
form.gain_db.value = (gain_from_ratio(form.v_in.value, form.v_out.value)).toFixed(2);
}

function output_voltage_from_gain(form) {
form.v_out.value = (vout_from_gain(form.v_in.value, form.db_gain.value)).toFixed(2);
}

function getpeaksplsimple(form) {
form.peakspl.value = (peakspl(form.sensitivity.value, form.power.value)).toFixed(0);
}

function getpeakspl(form) {
var eff = form.sensitivity.value * 1;
var ampgain = 10 * Math.log10(form.power.value);
var distanceloss = -20 * Math.log10(form.distance.value);
var qtygain = 10 * (Math.log10(form.qty.value));
var roomgain = form.room.value * 1;
var spl = eff + ampgain + distanceloss + qtygain + (roomgain * 1);

form.ampdb.value = Math.round(ampgain);
form.distancedb.value = Math.round(distanceloss);
form.qtydb.value = Math.round(qtygain);
form.roomdb.value = Math.round(roomgain);
form.peakspl.value = Math.round(spl);
form.speakerdb.value = eff;
}

function thdn_audibility(form) {
var eff = form.sensitivity.value * 1;
var ampgain = 10 * Math.log10(form.power.value);
var distanceloss = -20 * Math.log10(form.distance.value);
var qtygain = 10 * (Math.log10(form.qty.value * form.power.value) - Math.log10(form.power.value));
var roomgain = form.room.value * 1;
var spl = eff + ampgain + distanceloss + qtygain + roomgain * 1;

form.ampdb.value = Math.round(ampgain);
form.speakerdb.value = (form.sensitivity.value *1);
form.qtydb.value = Math.round(qtygain);
form.distancedb.value = Math.round(distanceloss);
form.roomdb.value = Math.round(roomgain);
form.peakspl.value = Math.round(spl);
form.thdspl.value = Math.round(spl - Math.abs(form.thddb.value));
}

function thdn_audibility_simple(form) {
var eff = form.sensitivity.value * 1;
var ampgain = 10 * Math.log10(form.power.value);
var distanceloss = -20 * Math.log10(form.distance.value);
var qtygain = 10 * (Math.log10(form.qty.value * form.power.value) - Math.log10(form.power.value));
var roomgain = form.room.value * 1;
var spl = eff + ampgain + distanceloss + qtygain + roomgain * 1;

form.peakspl.value = Math.round(spl);
form.thdspl.value = Math.round(spl - Math.abs(form.thddb.value));
}

function noise_audibility(form) {
var eff = form.sensitivity.value * 1;
var ampgain = 10 * Math.log10(form.power.value);
var distanceloss = -20 * Math.log10(form.distance.value);
var qtygain = 10 * (Math.log10(form.qty.value * form.power.value) - Math.log10(form.power.value));
var roomgain = form.room.value * 1;
var spl = eff + ampgain + distanceloss + qtygain + roomgain * 1;

form.ampdb.value = Math.round(ampgain);
form.speakerdb.value = (form.sensitivity.value *1);
form.qtydb.value = Math.round(qtygain);
form.distancedb.value = Math.round(distanceloss);
form.roomdb.value = Math.round(roomgain);
form.peakspl.value = Math.round(spl);
form.noisespl.value = Math.round(spl - Math.abs(form.snr.value));
}

function speaker_eff_to_sens(form) {
form.sens.value = (p_to_v_sensitivity(form.psens.value * 1, form.impedance.value * 1)).toFixed(1);
}

function speaker_sensitivity(form) {
var corr = gain_from_ratio(power_to_vrms(1, form.impedance.value *1),2.83);
if ((form.sens_units.value *1) > 0){
form.v_sens.value = (form.sens.value *1).toFixed(1);
form.p_sens.value = ((form.sens.value *1) - corr).toFixed(1);
} else {
form.p_sens.value = (form.sens.value *1).toFixed(1);
form.v_sens.value = ((form.sens.value *1) + corr).toFixed(1);
}
}

function snr_to_output_noise(form) {
form.noise_dbu.value = form.output_dbu.value - form.snr.value;
form.noise_uv.value = (1000000 * Math.pow(10,(form.noise_dbu.value/ 20)) * Math.sqrt(0.6)).toFixed(2);
form.noise_dbu.value = (form.noise_dbu.value *1).toFixed(1);
}

function vin_and_snr_to_output_noise(form) {
form.output_dbu.value = 20 * Math.log10(form.output_volts.value / Math.sqrt(0.6));
form.noise_dbu.value = form.output_dbu.value - form.snr.value;
form.noise_uv.value = (1000000 * Math.pow(10,(form.noise_dbu.value/ 20)) * Math.sqrt(0.6)).toFixed(2);
form.noise_dbu.value = (form.noise_dbu.value *1).toFixed(1);
form.output_dbu.value = (form.output_dbu.value *1).toFixed(1);
}

function benchmark_system_calc(form) {
var amp_gain = (power_to_dbu(100,8) - 22) + (6.02 * form.mono.value);
var eff = form.sensitivity.value * 1;
var amp_dbu_in =  (1 * form.dac_output.value) + (form.preamp_gain.value * 1);
var amp_dbu_out =  amp_gain + amp_dbu_in;
var amp_vout = dbu_to_vrms(amp_dbu_out);
var amp_clip = 22

if ((form.mono.value * 1) > 0){
	if ((form.ohms.value * 1) < 8){
	amp_clip = amp_clip - 1.9;
	} else {
	amp_clip = amp_clip - 0.2;
	}
} else {
	if ((form.ohms.value * 1) < 8){
	amp_clip = amp_clip - 0.2;
	} else {
	}
}

eff = eff + (form.sens_units.value * 10 * Math.log10(8 / form.ohms.value));

if (amp_dbu_in > amp_clip) {
amp_dbu_out = amp_clip + amp_gain;
amp_vout = dbu_to_vrms(amp_dbu_out);
form.status.value = 'Amplifier Clipping!';
} else {
form.status.value = (amp_clip - amp_dbu_in).toFixed(1);

}
form.peak_power.value = (dbu_to_power(amp_dbu_out, form.ohms.value * 1)).toFixed(2);
var distanceloss = -20 * Math.log10(form.distance.value * 1);
var qtygain = 10 * (Math.log10(form.qty.value * 1));
var roomgain = form.room.value * 1;


form.ampdb.value = dbu_to_dbw(amp_dbu_out,8);
var spl = eff + distanceloss + qtygain + roomgain + (form.ampdb.value *1);

form.ampdb.value = (form.ampdb.value * 1).toFixed(1);
form.distancedb.value = Math.round(distanceloss);
form.qtydb.value = Math.round(qtygain);
form.roomdb.value = Math.round(roomgain);
form.peakspl.value = Math.round(spl);
form.speakerdb.value = Math.round(eff);
}

function ahb2_spl_calc(form) {
var amp_gain = form.gain.value * 1;
var eff = form.sensitivity.value * 1;
var amp_dbu_in =  form.dbu_in.value * 1;

if (form.vrms_units.value > 0){
amp_dbu_in = vrms_to_dbu(amp_dbu_in);
} else {
}

var amp_dbu_out =  amp_gain + amp_dbu_in + (6.02 * form.mono.value);
var amp_vout = dbu_to_vrms(amp_dbu_out);
var amp_clip = 31.25 - amp_gain;

if ((form.mono.value * 1) > 0){
	if ((form.ohms.value * 1) < 8){
	amp_clip = amp_clip - 1.9;
	} else {
	amp_clip = amp_clip - 0.2;
	}
} else {
	if ((form.ohms.value * 1) < 8){
	amp_clip = amp_clip - 0.2;
	} else {
	}
}

eff = eff + (form.sens_units.value * 10 * Math.log10(8 / form.ohms.value));

if (amp_dbu_in > amp_clip) {
amp_dbu_out = amp_clip + amp_gain + (6.02 * form.mono.value);
amp_vout = dbu_to_vrms(amp_dbu_out);
form.status.value = 'Amplifier Clipping!';
} else {
form.status.value = (amp_clip - amp_dbu_in).toFixed(1);

}
form.peak_power.value = (dbu_to_power(amp_dbu_out, form.ohms.value * 1)).toFixed(2);
var distanceloss = -20 * Math.log10(form.distance.value * 1);
var qtygain = 10 * (Math.log10(form.qty.value * 1));
var roomgain = form.room.value * 1;


form.ampdb.value = dbu_to_dbw(amp_dbu_out,8);
var spl = eff + distanceloss + qtygain + roomgain + (form.ampdb.value *1);

form.ampdb.value = (form.ampdb.value * 1).toFixed(1);
form.distancedb.value = Math.round(distanceloss);
form.qtydb.value = Math.round(qtygain);
form.roomdb.value = Math.round(roomgain);
form.peakspl.value = Math.round(spl);
form.speakerdb.value = Math.round(eff);
}

function ahb2_calc(form) {
var amp_gain = form.gain.value * 1;
var amp_dbu_in =  form.dbu_in.value * 1;

if (form.vrms_units.value > 0){
amp_dbu_in = vrms_to_dbu(amp_dbu_in);
} else {
}

var amp_dbu_out =  amp_gain + amp_dbu_in + (6.02 * form.mono.value);
var amp_vout = dbu_to_vrms(amp_dbu_out);
var amp_clip = 31.25 - amp_gain;

if ((form.mono.value * 1) > 0){
	if ((form.ohms.value * 1) < 8){
	amp_clip = amp_clip - 1.9;
	} else {
	amp_clip = amp_clip - 0.2;
	}
} else {
	if ((form.ohms.value * 1) < 8){
	amp_clip = amp_clip - 0.2;
	} else {
	}
}


if (amp_dbu_in > amp_clip) {
amp_dbu_out = amp_clip + amp_gain + (6.02 * form.mono.value);
amp_vout = dbu_to_vrms(amp_dbu_out);
form.status.value = 'Amplifier Clipping!';
} else {
form.status.value = (amp_clip - amp_dbu_in).toFixed(1);

}
form.peak_power.value = (dbu_to_power(amp_dbu_out, form.ohms.value * 1)).toFixed(2);
form.ampdb.value = dbu_to_dbw(amp_dbu_out,8);
form.ampdbw.value = (dbu_to_dbw(amp_dbu_out,form.ohms.value *1)).toFixed(1);  
form.ampdbu.value = (amp_dbu_out).toFixed(1);
form.ampdb.value = (form.ampdb.value * 1).toFixed(1);
form.ampvrms.value = (dbu_to_vrms(amp_dbu_out)).toFixed(2);
}

function snr_enob(form) {
form.enob.value = (snr_to_enob(form.sinad.value *1)).toFixed(1);
}

function enob_snr(form) {
form.sinad.value = (enob_to_snr(form.enob.value *1)).toFixed(1);
}

function benchmark_hpa4_calc(form) {
var eff = form.sensitivity.value * 1;
var amp_dbu_out =  (1 * form.dac_output.value) + (form.preamp_gain.value * 1);
var amp_dbv = dbu_to_dbv(amp_dbu_out);
var amp_clip = vrms_to_dbu(11.5 * (form.ohms.value / ((form.ohms.value * 1) + 2.78)));
eff = eff + (form.sens_units.value * 10 * Math.log10(1000 / form.ohms.value));

if (amp_dbu_out > amp_clip) {
amp_dbu_out = amp_clip;
amp_dbv = dbu_to_dbv(amp_dbu_out);
form.status.value = 'Amplifier Clipping!';
} else {
form.status.value = (amp_clip - amp_dbu_out).toFixed(1);
}

form.peak_power.value = (1000 * dbu_to_power(amp_dbu_out, form.ohms.value * 1)).toFixed(0);
form.peak_power_dbm.value = (mw_to_dbm(form.peak_power.value * 1)).toFixed(1); 
form.headphone_dbv.value = (amp_dbv).toFixed(1);
var spl = eff + amp_dbv;
form.peakspl.value = (spl).toFixed(1);
}

function watts_dbw(form) {
form.dbm.value = (mw_to_dbm(form.watts.value * 1000)).toFixed(3);
form.dbw.value = (watts_to_dbw(form.watts.value)).toFixed(3);
}

function mw_dbm(form) {
form.dbm.value = (mw_to_dbm(form.mw.value)).toFixed(3);
form.dbw.value = (watts_to_dbw(form.mw.value /1000)).toFixed(3);
}

function dbw_watts(form) {
form.dbm.value = ((form.dbw.value * 1) + 30).toFixed(3);
form.watts.value = (dbw_to_watts(form.dbw.value)).toFixed(3);
}

function dbm_mw(form) {
form.dbw.value = ((form.dbm.value * 1) - 30).toFixed(3);
form.mw.value = (dbm_to_mw(form.dbm.value)).toFixed(3);
}

function headphone_sensitivity(form) {
var corr = gain_from_ratio(power_to_vrms(0.001, form.impedance.value *1),1);
if ((form.sens_units.value *1) > 0){
form.v_sens.value = (form.sens.value *1).toFixed(1);
form.p_sens.value = ((form.sens.value *1) - corr).toFixed(1);
} else {
form.p_sens.value = (form.sens.value *1).toFixed(1);
form.v_sens.value = ((form.sens.value *1) + corr).toFixed(1);
}
}

function noise_sum_db(form) {
form.noise_out.value = (10 * Math.log10(Math.pow(10,form.noise1.value/10) + Math.pow(10,form.noise2.value/10))).toFixed(2);
}

function noise_sum_v(form) {
form.noise_out.value = (Math.sqrt(Math.pow(form.noise1.value,2) + Math.pow(form.noise2.value,2))).toFixed(4);
}